export default __webpack_public_path__ + "cockroach-topview-Sprites.png?4fccde29029dd1126364da9eb9f8039b";